import type { JSX } from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';

import { useOverwritePaymentMethodConfirmationModal } from './hooks/useOverwritePaymentMethodConfirmationModal';

export function OverwritePaymentMethodConfirmationModal(): JSX.Element {
	const {
		data: { title, text, cancelLabel, confirmLabel, confirmDataQa, cancelDataQa, showOverwritePaymentMethodModal },
		actions: { confirmPaymentMethodOverwrite, cancelPaymentMethodOverwrite },
	} = useOverwritePaymentMethodConfirmationModal();

	return (
		<Modal
			isOpen={showOverwritePaymentMethodModal}
			aria-label="Overwrite Payment Method Confirmation Modal"
			onClose={cancelPaymentMethodOverwrite}
			className="z-[999] [&>*]:!min-h-[100px]"
			size="small"
		>
			<ModalHeader
				title={
					<Text size="x-small" className="font-bold">
						{title}
					</Text>
				}
			/>
			<ModalBody>
				<div className="mx-auto flex flex-col items-center gap-4">
					<Text size="medium">{text}</Text>
				</div>
			</ModalBody>
			<ModalFooter>
				<div className="flex w-full flex-col gap-4">
					<Button onClick={confirmPaymentMethodOverwrite} data-qa={confirmDataQa} variant="primary" size="small">
						{confirmLabel}
					</Button>
					<Button onClick={cancelPaymentMethodOverwrite} data-qa={cancelDataQa} variant="secondary" size="small">
						{cancelLabel}
					</Button>
				</div>
			</ModalFooter>
		</Modal>
	);
}
